/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Console_Nav_HomeInputs */
/** @typedef {{}} Console_Nav_InboxInputs */
/** @typedef {{}} Console_Nav_KnowledgeInputs */
/** @typedef {{}} Console_Nav_PlaygroundInputs */
/** @typedef {{}} Console_Nav_SettingsInputs */
/** @typedef {{}} Console_Store_ChannelInputs */
/** @typedef {{}} Console_Store_Open_In_ShopifyInputs */
/** @typedef {{}} Console_Theme_DarkInputs */
/** @typedef {{}} Console_Theme_LightInputs */
/** @typedef {{}} Console_Theme_SystemInputs */
/** @typedef {{}} Home_Empty_No_Conversations_BodyInputs */
/** @typedef {{}} Home_Empty_No_Conversations_HeadingInputs */
/** @typedef {{ store: NonNullable<unknown> }} Home_Empty_No_Conversations_NoteInputs */
/** @typedef {{}} Home_Empty_No_Knowledge_BodyInputs */
/** @typedef {{}} Home_Empty_No_Knowledge_HeadingInputs */
/** @typedef {{}} Home_Empty_Storefront_Not_Live_BodyInputs */
/** @typedef {{}} Home_Empty_Storefront_Not_Live_HeadingInputs */
/** @typedef {{}} Home_Metric_Ai_Resolution_HelpInputs */
/** @typedef {{}} Home_Metric_Ai_Resolution_LabelInputs */
/** @typedef {{ change: NonNullable<unknown> }} Home_Metric_Change_CountInputs */
/** @typedef {{ change: NonNullable<unknown> }} Home_Metric_Change_PointsInputs */
/** @typedef {{}} Home_Metric_Change_UnavailableInputs */
/** @typedef {{}} Home_Metric_Conversations_HelpInputs */
/** @typedef {{}} Home_Metric_Conversations_LabelInputs */
/** @typedef {{ metric: NonNullable<unknown> }} Home_Metric_Help_LabelInputs */
/** @typedef {{}} Home_Metric_Human_Backstop_HelpInputs */
/** @typedef {{}} Home_Metric_Human_Backstop_LabelInputs */
/** @typedef {{}} Home_Metric_Value_UnavailableInputs */
/** @typedef {{}} Home_Metrics_Failure_ForbiddenInputs */
/** @typedef {{}} Home_Metrics_Failure_NetworkInputs */
/** @typedef {{}} Home_Metrics_Failure_RejectedInputs */
/** @typedef {{}} Home_Metrics_Failure_SchemaInputs */
/** @typedef {{}} Home_Metrics_Failure_UnexpectedInputs */
/** @typedef {{}} Home_Metrics_LoadingInputs */
/** @typedef {{}} Home_Page_TitleInputs */
/** @typedef {{}} Home_Period_LabelInputs */
/** @typedef {{}} Home_Period_Last_30_DaysInputs */
/** @typedef {{}} Home_Period_Last_7_DaysInputs */
/** @typedef {{}} Home_Store_Connection_LoadingInputs */
/** @typedef {{}} Home_Trend_Chart_Label_DailyInputs */
/** @typedef {{}} Home_Trend_Chart_Label_WeeklyInputs */
/** @typedef {{}} Home_Trend_Series_Ai_ResolvedInputs */
/** @typedef {{}} Home_Trend_Series_ConversationsInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Home_Trend_Subtitle_DailyInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Home_Trend_Subtitle_WeeklyInputs */
/** @typedef {{}} Home_Trend_TitleInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Home_Trend_Tooltip_RangeInputs */
/** @typedef {{ time: NonNullable<unknown> }} Home_Updated_AtInputs */
/** @typedef {{}} Inbox_Conversation_HandoffInputs */
/** @typedef {{ count: NonNullable<unknown> }} Inbox_Conversation_Message_CountInputs */
/** @typedef {{}} Inbox_Conversation_Message_Count_OneInputs */
/** @typedef {{}} Inbox_Conversation_Request_SentInputs */
/** @typedef {{}} Inbox_Conversations_Failure_ForbiddenInputs */
/** @typedef {{}} Inbox_Conversations_Failure_NetworkInputs */
/** @typedef {{}} Inbox_Conversations_Failure_RejectedInputs */
/** @typedef {{}} Inbox_Conversations_Failure_SchemaInputs */
/** @typedef {{}} Inbox_Conversations_Failure_UnexpectedInputs */
/** @typedef {{}} Inbox_List_Empty_BodyInputs */
/** @typedef {{}} Inbox_List_Empty_HeadingInputs */
/** @typedef {{}} Inbox_List_HeadingInputs */
/** @typedef {{}} Inbox_List_Load_MoreInputs */
/** @typedef {{}} Inbox_List_LoadingInputs */
/** @typedef {{}} Inbox_List_Loading_MoreInputs */
/** @typedef {{}} Inbox_Page_TitleInputs */
/** @typedef {{}} Inbox_Replay_BackInputs */
/** @typedef {{}} Inbox_Replay_Empty_BodyInputs */
/** @typedef {{}} Inbox_Replay_Empty_HeadingInputs */
/** @typedef {{}} Inbox_Replay_Feedback_NegativeInputs */
/** @typedef {{}} Inbox_Replay_Feedback_PositiveInputs */
/** @typedef {{}} Inbox_Replay_LoadingInputs */
/** @typedef {{ started: NonNullable<unknown>, last: NonNullable<unknown> }} Inbox_Replay_MetaInputs */
/** @typedef {{}} Inbox_Replay_Read_OnlyInputs */
/** @typedef {{}} Inbox_Replay_Transcript_LabelInputs */
/** @typedef {{}} Knowledge_Category_AllInputs */
/** @typedef {{}} Knowledge_Category_EmptyInputs */
/** @typedef {{}} Knowledge_Category_LabelInputs */
/** @typedef {{}} Knowledge_Category_NoneInputs */
/** @typedef {{}} Knowledge_Category_SearchInputs */
/** @typedef {{}} Knowledge_Column_CategoryInputs */
/** @typedef {{}} Knowledge_Column_InventoryInputs */
/** @typedef {{}} Knowledge_Column_PriceInputs */
/** @typedef {{}} Knowledge_Column_ProductInputs */
/** @typedef {{}} Knowledge_Column_VariantsInputs */
/** @typedef {{}} Knowledge_Empty_Products_BodyInputs */
/** @typedef {{}} Knowledge_Empty_Products_HeadingInputs */
/** @typedef {{}} Knowledge_Empty_Questions_BodyInputs */
/** @typedef {{}} Knowledge_Empty_Questions_HeadingInputs */
/** @typedef {{}} Knowledge_Empty_Search_BodyInputs */
/** @typedef {{}} Knowledge_Empty_Search_HeadingInputs */
/** @typedef {{}} Knowledge_Failure_ForbiddenInputs */
/** @typedef {{}} Knowledge_Failure_NetworkInputs */
/** @typedef {{}} Knowledge_Failure_RejectedInputs */
/** @typedef {{}} Knowledge_Failure_SchemaInputs */
/** @typedef {{}} Knowledge_Failure_UnexpectedInputs */
/** @typedef {{}} Knowledge_Inventory_UntrackedInputs */
/** @typedef {{}} Knowledge_Load_MoreInputs */
/** @typedef {{}} Knowledge_LoadingInputs */
/** @typedef {{}} Knowledge_Loading_MoreInputs */
/** @typedef {{}} Knowledge_Page_TitleInputs */
/** @typedef {{ category: NonNullable<unknown>, price: NonNullable<unknown>, inventory: NonNullable<unknown>, variants: NonNullable<unknown> }} Knowledge_Product_MetaInputs */
/** @typedef {{}} Knowledge_Search_LabelInputs */
/** @typedef {{}} Knowledge_Search_PlaceholderInputs */
/** @typedef {{}} Knowledge_Tab_ProductsInputs */
/** @typedef {{}} Knowledge_Tab_QuestionsInputs */
/** @typedef {{}} Knowledge_Tabs_LabelInputs */
/** @typedef {{}} Knowledge_Test_In_PlaygroundInputs */
/** @typedef {{}} Playground_Failure_ForbiddenInputs */
/** @typedef {{}} Playground_Failure_NetworkInputs */
/** @typedef {{}} Playground_Failure_RejectedInputs */
/** @typedef {{}} Playground_Failure_SchemaInputs */
/** @typedef {{}} Playground_Failure_UnexpectedInputs */
/** @typedef {{}} Playground_Live_ConfigInputs */
/** @typedef {{}} Playground_Page_TitleInputs */
/** @typedef {{}} Playground_Real_Business_NoticeInputs */
/** @typedef {{}} Playground_ResetInputs */
/** @typedef {{}} Settings_Agent_CopyInputs */
/** @typedef {{}} Settings_Agent_Name_LabelInputs */
/** @typedef {{}} Settings_Character_HintInputs */
/** @typedef {{}} Settings_Character_LabelInputs */
/** @typedef {{}} Settings_Character_SolidInputs */
/** @typedef {{}} Settings_Character_WatercolorInputs */
/** @typedef {{}} Settings_Color_Picker_LabelInputs */
/** @typedef {{}} Settings_Color_Shape_HeadingInputs */
/** @typedef {{}} Settings_Copy_Button_CopyInputs */
/** @typedef {{}} Settings_Copy_Button_TitleInputs */
/** @typedef {{}} Settings_Direction_EditorialInputs */
/** @typedef {{}} Settings_Direction_HairlineInputs */
/** @typedef {{}} Settings_Direction_HintInputs */
/** @typedef {{}} Settings_Direction_LabelInputs */
/** @typedef {{}} Settings_Disable_CancelInputs */
/** @typedef {{}} Settings_Disable_ConfirmInputs */
/** @typedef {{}} Settings_Disable_DescriptionInputs */
/** @typedef {{}} Settings_Disable_TitleInputs */
/** @typedef {{}} Settings_DiscardInputs */
/** @typedef {{}} Settings_Error_Agent_NameInputs */
/** @typedef {{ tab: NonNullable<unknown> }} Settings_Error_Go_To_TabInputs */
/** @typedef {{}} Settings_Error_Proactive_RulesInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Error_Rule_PromptInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Error_Rule_QuestionInputs */
/** @typedef {{}} Settings_Error_Rule_SelectorInputs */
/** @typedef {{}} Settings_Error_Rule_WaitInputs */
/** @typedef {{}} Settings_Error_Suggested_QuestionInputs */
/** @typedef {{}} Settings_Error_Suggested_Question_DuplicateInputs */
/** @typedef {{}} Settings_Error_Support_EmailInputs */
/** @typedef {{}} Settings_Error_Tab_FieldsInputs */
/** @typedef {{}} Settings_Error_Theme_ColorInputs */
/** @typedef {{}} Settings_Error_Welcome_MessageInputs */
/** @typedef {{}} Settings_Failure_ForbiddenInputs */
/** @typedef {{}} Settings_Failure_NetworkInputs */
/** @typedef {{}} Settings_Failure_RejectedInputs */
/** @typedef {{}} Settings_Failure_SchemaInputs */
/** @typedef {{}} Settings_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Font_HintInputs */
/** @typedef {{}} Settings_Font_LabelInputs */
/** @typedef {{}} Settings_Font_SansInputs */
/** @typedef {{}} Settings_Font_SerifInputs */
/** @typedef {{}} Settings_Font_Size_LabelInputs */
/** @typedef {{}} Settings_Font_Size_LargeInputs */
/** @typedef {{}} Settings_Font_Size_SmallInputs */
/** @typedef {{}} Settings_Font_Size_StandardInputs */
/** @typedef {{}} Settings_Font_ThemeInputs */
/** @typedef {{}} Settings_Glass_HintInputs */
/** @typedef {{}} Settings_Glass_LabelInputs */
/** @typedef {{}} Settings_Glass_OffInputs */
/** @typedef {{}} Settings_Glass_OnInputs */
/** @typedef {{}} Settings_Handoff_CopyInputs */
/** @typedef {{}} Settings_Handoff_HeadingInputs */
/** @typedef {{}} Settings_Hex_LabelInputs */
/** @typedef {{}} Settings_Launcher_Drag_CopyInputs */
/** @typedef {{}} Settings_Launcher_Drag_TitleInputs */
/** @typedef {{}} Settings_Leave_CancelInputs */
/** @typedef {{}} Settings_Leave_ConfirmInputs */
/** @typedef {{}} Settings_Leave_DescriptionInputs */
/** @typedef {{}} Settings_Leave_TitleInputs */
/** @typedef {{}} Settings_LoadingInputs */
/** @typedef {{}} Settings_Logo_AltInputs */
/** @typedef {{}} Settings_Logo_Failure_Too_LargeInputs */
/** @typedef {{}} Settings_Logo_Failure_TypeInputs */
/** @typedef {{}} Settings_Logo_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Logo_File_LabelInputs */
/** @typedef {{}} Settings_Logo_HintInputs */
/** @typedef {{}} Settings_Logo_LabelInputs */
/** @typedef {{}} Settings_Logo_RemoveInputs */
/** @typedef {{}} Settings_Logo_ReplaceInputs */
/** @typedef {{}} Settings_Logo_UploadInputs */
/** @typedef {{}} Settings_Messages_HeadingInputs */
/** @typedef {{}} Settings_Page_TitleInputs */
/** @typedef {{}} Settings_Position_Bottom_LeftInputs */
/** @typedef {{}} Settings_Position_Bottom_RightInputs */
/** @typedef {{}} Settings_Position_LabelInputs */
/** @typedef {{}} Settings_Preview_ConversationInputs */
/** @typedef {{}} Settings_Preview_DesktopInputs */
/** @typedef {{}} Settings_Preview_Device_LabelInputs */
/** @typedef {{}} Settings_Preview_HeadingInputs */
/** @typedef {{}} Settings_Preview_HiddenInputs */
/** @typedef {{}} Settings_Preview_LauncherInputs */
/** @typedef {{}} Settings_Preview_MobileInputs */
/** @typedef {{}} Settings_Preview_ProactiveInputs */
/** @typedef {{}} Settings_Preview_Store_NameInputs */
/** @typedef {{}} Settings_Preview_View_LabelInputs */
/** @typedef {{}} Settings_Proactive_AddInputs */
/** @typedef {{}} Settings_Proactive_CopyInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_DeleteInputs */
/** @typedef {{}} Settings_Proactive_Delete_CancelInputs */
/** @typedef {{}} Settings_Proactive_Delete_ConfirmInputs */
/** @typedef {{}} Settings_Proactive_Delete_DescriptionInputs */
/** @typedef {{}} Settings_Proactive_Delete_TitleInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_EditInputs */
/** @typedef {{}} Settings_Proactive_Empty_BodyInputs */
/** @typedef {{}} Settings_Proactive_Empty_HeadingInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_EnableInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Settings_Proactive_Field_CountInputs */
/** @typedef {{}} Settings_Proactive_HeadingInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Proactive_Insert_PlaceholderInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_Move_DownInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_Move_UpInputs */
/** @typedef {{}} Settings_Proactive_No_PromptInputs */
/** @typedef {{}} Settings_Proactive_PickInputs */
/** @typedef {{}} Settings_Proactive_Pick_AgainInputs */
/** @typedef {{}} Settings_Proactive_Pick_AppliedInputs */
/** @typedef {{}} Settings_Proactive_Pick_BlockedInputs */
/** @typedef {{}} Settings_Proactive_Pick_CancelInputs */
/** @typedef {{}} Settings_Proactive_Pick_Cancel_FailedInputs */
/** @typedef {{}} Settings_Proactive_Pick_ConflictInputs */
/** @typedef {{}} Settings_Proactive_Pick_Conflict_BlockedInputs */
/** @typedef {{}} Settings_Proactive_Pick_DismissInputs */
/** @typedef {{}} Settings_Proactive_Pick_Embed_HintInputs */
/** @typedef {{}} Settings_Proactive_Pick_Failure_PopupInputs */
/** @typedef {{}} Settings_Proactive_Pick_Failure_RejectedInputs */
/** @typedef {{}} Settings_Proactive_Pick_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Proactive_Pick_GoneInputs */
/** @typedef {{}} Settings_Proactive_Pick_KeepInputs */
/** @typedef {{}} Settings_Proactive_Pick_Save_FirstInputs */
/** @typedef {{}} Settings_Proactive_Pick_UseInputs */
/** @typedef {{}} Settings_Proactive_PickingInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Proactive_Prompt_HintInputs */
/** @typedef {{}} Settings_Proactive_Prompt_LabelInputs */
/** @typedef {{ placeholder: NonNullable<unknown> }} Settings_Proactive_Question_HintInputs */
/** @typedef {{}} Settings_Proactive_Question_LabelInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Proactive_RuleInputs */
/** @typedef {{}} Settings_Proactive_Selector_HintInputs */
/** @typedef {{}} Settings_Proactive_Selector_LabelInputs */
/** @typedef {{}} Settings_Proactive_Target_RequiredInputs */
/** @typedef {{}} Settings_Proactive_Trigger_ElementInputs */
/** @typedef {{}} Settings_Proactive_Trigger_Element_HintInputs */
/** @typedef {{}} Settings_Proactive_Trigger_EntryInputs */
/** @typedef {{}} Settings_Proactive_Trigger_Entry_HintInputs */
/** @typedef {{}} Settings_Proactive_Trigger_IdleInputs */
/** @typedef {{}} Settings_Proactive_Trigger_Idle_HintInputs */
/** @typedef {{}} Settings_Proactive_Trigger_LabelInputs */
/** @typedef {{}} Settings_Proactive_Wait_LabelInputs */
/** @typedef {{}} Settings_Proactive_Wait_SuffixInputs */
/** @typedef {{}} Settings_Prompt_Style_BodyInputs */
/** @typedef {{}} Settings_Prompt_Style_BubbleInputs */
/** @typedef {{}} Settings_Prompt_Style_HintInputs */
/** @typedef {{}} Settings_Prompt_Style_LabelInputs */
/** @typedef {{}} Settings_Radius_LabelInputs */
/** @typedef {{}} Settings_Radius_PresetInputs */
/** @typedef {{}} Settings_Radius_RoundInputs */
/** @typedef {{}} Settings_Radius_RoundedInputs */
/** @typedef {{}} Settings_Radius_SquareInputs */
/** @typedef {{}} Settings_SaveInputs */
/** @typedef {{}} Settings_Save_FailedInputs */
/** @typedef {{}} Settings_Save_Failure_RejectedInputs */
/** @typedef {{}} Settings_Save_Failure_UnexpectedInputs */
/** @typedef {{}} Settings_Save_HintInputs */
/** @typedef {{}} Settings_Save_SuccessInputs */
/** @typedef {{}} Settings_SavedInputs */
/** @typedef {{}} Settings_SavingInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_LabelInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_Move_DownInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_Move_UpInputs */
/** @typedef {{ position: NonNullable<unknown> }} Settings_Suggested_Question_RemoveInputs */
/** @typedef {{}} Settings_Suggested_Questions_AddInputs */
/** @typedef {{}} Settings_Suggested_Questions_HintInputs */
/** @typedef {{}} Settings_Suggested_Questions_LabelInputs */
/** @typedef {{}} Settings_Suggested_Questions_LimitInputs */
/** @typedef {{}} Settings_Support_Email_HintInputs */
/** @typedef {{}} Settings_Support_Email_LabelInputs */
/** @typedef {{}} Settings_Support_Failed_BodyInputs */
/** @typedef {{}} Settings_Support_Failed_TitleInputs */
/** @typedef {{}} Settings_Support_Hint_UnsavedInputs */
/** @typedef {{}} Settings_Support_Hint_VerifiedInputs */
/** @typedef {{}} Settings_Support_Mark_UnsavedInputs */
/** @typedef {{}} Settings_Support_Mark_UnverifiedInputs */
/** @typedef {{}} Settings_Support_Mark_VerifiedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Settings_Support_Pending_BodyInputs */
/** @typedef {{}} Settings_Support_Pending_TitleInputs */
/** @typedef {{}} Settings_Support_ResendInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Settings_Support_Resend_WaitInputs */
/** @typedef {{}} Settings_Support_Resent_BodyInputs */
/** @typedef {{}} Settings_Support_Resent_TitleInputs */
/** @typedef {{}} Settings_Support_SendInputs */
/** @typedef {{}} Settings_Support_SendingInputs */
/** @typedef {{ time: NonNullable<unknown> }} Settings_Support_Sent_AtInputs */
/** @typedef {{}} Settings_Support_Try_AgainInputs */
/** @typedef {{}} Settings_Support_Unavailable_BodyInputs */
/** @typedef {{}} Settings_Support_Unavailable_TitleInputs */
/** @typedef {{ email: NonNullable<unknown> }} Settings_Support_Unsent_BodyInputs */
/** @typedef {{}} Settings_Support_Unsent_TitleInputs */
/** @typedef {{}} Settings_Surface_DarkInputs */
/** @typedef {{}} Settings_Surface_HintInputs */
/** @typedef {{}} Settings_Surface_LabelInputs */
/** @typedef {{}} Settings_Surface_LightInputs */
/** @typedef {{}} Settings_Swatch_CustomInputs */
/** @typedef {{}} Settings_Swatch_DefaultInputs */
/** @typedef {{}} Settings_Swatch_ForestInputs */
/** @typedef {{}} Settings_Swatch_IndigoInputs */
/** @typedef {{}} Settings_Swatch_LuxuryInputs */
/** @typedef {{}} Settings_Swatch_MinimalInputs */
/** @typedef {{}} Settings_Swatch_PlayfulInputs */
/** @typedef {{}} Settings_Swatch_RoseInputs */
/** @typedef {{}} Settings_Swatch_WarmInputs */
/** @typedef {{}} Settings_Tab_AppearanceInputs */
/** @typedef {{}} Settings_Tab_Chat_WindowInputs */
/** @typedef {{}} Settings_Tab_HandoffInputs */
/** @typedef {{}} Settings_Tab_LauncherInputs */
/** @typedef {{}} Settings_Tab_Needs_AttentionInputs */
/** @typedef {{}} Settings_Tab_ProactiveInputs */
/** @typedef {{}} Settings_Tabs_LabelInputs */
/** @typedef {{}} Settings_Text_HeadingInputs */
/** @typedef {{}} Settings_Theme_Color_HintInputs */
/** @typedef {{}} Settings_Theme_Color_LabelInputs */
/** @typedef {{}} Settings_Theme_EditorInputs */
/** @typedef {{}} Settings_Title_Bar_HeadingInputs */
/** @typedef {{}} Settings_Visibility_PendingInputs */
/** @typedef {{}} Settings_Visibility_TitleInputs */
/** @typedef {{ count: NonNullable<unknown>, max: NonNullable<unknown> }} Settings_Welcome_CountInputs */
/** @typedef {{}} Settings_Welcome_HeadingInputs */
/** @typedef {{}} Settings_Welcome_HintInputs */
/** @typedef {{}} Settings_Welcome_LabelInputs */
/** @typedef {{}} Store_Connection_Error_HeadingInputs */
/** @typedef {{}} Store_Connection_Expired_HeadingInputs */
/** @typedef {{}} Store_Connection_Failure_ForbiddenInputs */
/** @typedef {{}} Store_Connection_Failure_NetworkInputs */
/** @typedef {{}} Store_Connection_Failure_RejectedInputs */
/** @typedef {{}} Store_Connection_Failure_SchemaInputs */
/** @typedef {{}} Store_Connection_Failure_UnexpectedInputs */
/** @typedef {{}} Store_Connection_Preparing_BodyInputs */
/** @typedef {{}} Store_Connection_Preparing_HeadingInputs */
/** @typedef {{}} Store_Connection_RefreshInputs */
/** @typedef {{}} Store_Entry_BodyInputs */
/** @typedef {{}} Store_Entry_HeadingInputs */


export const console_nav_home = /** @type {(inputs: Console_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

export const console_nav_inbox = /** @type {(inputs: Console_Nav_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

export const console_nav_knowledge = /** @type {(inputs: Console_Nav_KnowledgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge`)
};

export const console_nav_playground = /** @type {(inputs: Console_Nav_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playground`)
};

export const console_nav_settings = /** @type {(inputs: Console_Nav_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const console_store_channel = /** @type {(inputs: Console_Store_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shopify`)
};

export const console_store_open_in_shopify = /** @type {(inputs: Console_Store_Open_In_ShopifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in Shopify admin`)
};

export const console_theme_dark = /** @type {(inputs: Console_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark mode`)
};

export const console_theme_light = /** @type {(inputs: Console_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light mode`)
};

export const console_theme_system = /** @type {(inputs: Console_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

export const home_empty_no_conversations_body = /** @type {(inputs: Home_Empty_No_Conversations_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics appear here as soon as a shopper sends the first message through the storefront chat widget.`)
};

export const home_empty_no_conversations_heading = /** @type {(inputs: Home_Empty_No_Conversations_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your AI is ready — waiting for the first conversation`)
};

export const home_empty_no_conversations_note = /** @type {(inputs: Home_Empty_No_Conversations_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing to set up — the widget is already live on ${i?.store}`)
};

export const home_empty_no_knowledge_body = /** @type {(inputs: Home_Empty_No_Knowledge_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products and policies are still syncing. Metrics start once the AI has something to answer from.`)
};

export const home_empty_no_knowledge_heading = /** @type {(inputs: Home_Empty_No_Knowledge_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still preparing your store knowledge`)
};

export const home_empty_storefront_not_live_body = /** @type {(inputs: Home_Empty_Storefront_Not_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn the app embed on in your theme so shoppers can start conversations.`)
};

export const home_empty_storefront_not_live_heading = /** @type {(inputs: Home_Empty_Storefront_Not_Live_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The widget is not live on your storefront yet`)
};

export const home_metric_ai_resolution_help = /** @type {(inputs: Home_Metric_Ai_Resolution_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations completed by AI without human support.`)
};

export const home_metric_ai_resolution_label = /** @type {(inputs: Home_Metric_Ai_Resolution_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Resolution Rate`)
};

export const home_metric_change_count = /** @type {(inputs: Home_Metric_Change_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.change} vs prior period`)
};

export const home_metric_change_points = /** @type {(inputs: Home_Metric_Change_PointsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.change} pt vs prior period`)
};

export const home_metric_change_unavailable = /** @type {(inputs: Home_Metric_Change_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No prior period to compare`)
};

export const home_metric_conversations_help = /** @type {(inputs: Home_Metric_Conversations_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid storefront conversations; Playground tests excluded.`)
};

export const home_metric_conversations_label = /** @type {(inputs: Home_Metric_Conversations_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

export const home_metric_help_label = /** @type {(inputs: Home_Metric_Help_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.metric}`)
};

export const home_metric_human_backstop_help = /** @type {(inputs: Home_Metric_Human_Backstop_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations requiring human support.`)
};

export const home_metric_human_backstop_label = /** @type {(inputs: Home_Metric_Human_Backstop_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human backstop`)
};

export const home_metric_value_unavailable = /** @type {(inputs: Home_Metric_Value_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

export const home_metrics_failure_forbidden = /** @type {(inputs: Home_Metrics_Failure_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Reopen the admin from Shopify.`)
};

export const home_metrics_failure_network = /** @type {(inputs: Home_Metrics_Failure_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach GoNovus. Check your connection and try again.`)
};

export const home_metrics_failure_rejected = /** @type {(inputs: Home_Metrics_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics are unavailable right now.`)
};

export const home_metrics_failure_schema = /** @type {(inputs: Home_Metrics_Failure_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrics came back in an unexpected shape.`)
};

export const home_metrics_failure_unexpected = /** @type {(inputs: Home_Metrics_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong loading metrics.`)
};

export const home_metrics_loading = /** @type {(inputs: Home_Metrics_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading metrics`)
};

export const home_page_title = /** @type {(inputs: Home_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

export const home_period_label = /** @type {(inputs: Home_Period_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting period`)
};

export const home_period_last_30_days = /** @type {(inputs: Home_Period_Last_30_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 30 days`)
};

export const home_period_last_7_days = /** @type {(inputs: Home_Period_Last_7_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 7 days`)
};

export const home_store_connection_loading = /** @type {(inputs: Home_Store_Connection_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading store details`)
};

export const home_trend_chart_label_daily = /** @type {(inputs: Home_Trend_Chart_Label_DailyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily conversations and AI resolved conversations`)
};

export const home_trend_chart_label_weekly = /** @type {(inputs: Home_Trend_Chart_Label_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly totals of conversations and AI resolved conversations`)
};

export const home_trend_series_ai_resolved = /** @type {(inputs: Home_Trend_Series_Ai_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI resolved`)
};

export const home_trend_series_conversations = /** @type {(inputs: Home_Trend_Series_ConversationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

export const home_trend_subtitle_daily = /** @type {(inputs: Home_Trend_Subtitle_DailyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Daily · ${i?.start} – ${i?.end}`)
};

export const home_trend_subtitle_weekly = /** @type {(inputs: Home_Trend_Subtitle_WeeklyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weekly totals · ${i?.start} – ${i?.end}`)
};

export const home_trend_title = /** @type {(inputs: Home_Trend_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations & AI resolution`)
};

export const home_trend_tooltip_range = /** @type {(inputs: Home_Trend_Tooltip_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.start} – ${i?.end}`)
};

export const home_updated_at = /** @type {(inputs: Home_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.time}`)
};

export const inbox_conversation_handoff = /** @type {(inputs: Inbox_Conversation_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handed off`)
};

export const inbox_conversation_message_count = /** @type {(inputs: Inbox_Conversation_Message_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} messages`)
};

export const inbox_conversation_message_count_one = /** @type {(inputs: Inbox_Conversation_Message_Count_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 message`)
};

export const inbox_conversation_request_sent = /** @type {(inputs: Inbox_Conversation_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request sent`)
};

export const inbox_conversations_failure_forbidden = /** @type {(inputs: Inbox_Conversations_Failure_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Reopen the admin from Shopify.`)
};

export const inbox_conversations_failure_network = /** @type {(inputs: Inbox_Conversations_Failure_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach GoNovus. Check your connection and try again.`)
};

export const inbox_conversations_failure_rejected = /** @type {(inputs: Inbox_Conversations_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations are unavailable right now.`)
};

export const inbox_conversations_failure_schema = /** @type {(inputs: Inbox_Conversations_Failure_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations came back in an unexpected shape.`)
};

export const inbox_conversations_failure_unexpected = /** @type {(inputs: Inbox_Conversations_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong loading conversations.`)
};

export const inbox_list_empty_body = /** @type {(inputs: Inbox_List_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations appear here once shoppers start chatting.`)
};

export const inbox_list_empty_heading = /** @type {(inputs: Inbox_List_Empty_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No conversations yet`)
};

export const inbox_list_heading = /** @type {(inputs: Inbox_List_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

export const inbox_list_load_more = /** @type {(inputs: Inbox_List_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

export const inbox_list_loading = /** @type {(inputs: Inbox_List_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading conversations`)
};

export const inbox_list_loading_more = /** @type {(inputs: Inbox_List_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading more conversations`)
};

export const inbox_page_title = /** @type {(inputs: Inbox_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

export const inbox_replay_back = /** @type {(inputs: Inbox_Replay_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All conversations`)
};

export const inbox_replay_empty_body = /** @type {(inputs: Inbox_Replay_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a conversation from the list to replay it message by message.`)
};

export const inbox_replay_empty_heading = /** @type {(inputs: Inbox_Replay_Empty_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a conversation`)
};

export const inbox_replay_feedback_negative = /** @type {(inputs: Inbox_Replay_Feedback_NegativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked not helpful`)
};

export const inbox_replay_feedback_positive = /** @type {(inputs: Inbox_Replay_Feedback_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marked helpful`)
};

export const inbox_replay_loading = /** @type {(inputs: Inbox_Replay_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading the conversation`)
};

export const inbox_replay_meta = /** @type {(inputs: Inbox_Replay_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Started ${i?.started} · last message ${i?.last}`)
};

export const inbox_replay_read_only = /** @type {(inputs: Inbox_Replay_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read-only`)
};

export const inbox_replay_transcript_label = /** @type {(inputs: Inbox_Replay_Transcript_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation replay`)
};

export const knowledge_category_all = /** @type {(inputs: Knowledge_Category_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All categories`)
};

export const knowledge_category_empty = /** @type {(inputs: Knowledge_Category_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No categories found`)
};

export const knowledge_category_label = /** @type {(inputs: Knowledge_Category_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

export const knowledge_category_none = /** @type {(inputs: Knowledge_Category_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uncategorized`)
};

export const knowledge_category_search = /** @type {(inputs: Knowledge_Category_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search categories`)
};

export const knowledge_column_category = /** @type {(inputs: Knowledge_Column_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

export const knowledge_column_inventory = /** @type {(inputs: Knowledge_Column_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory`)
};

export const knowledge_column_price = /** @type {(inputs: Knowledge_Column_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

export const knowledge_column_product = /** @type {(inputs: Knowledge_Column_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product`)
};

export const knowledge_column_variants = /** @type {(inputs: Knowledge_Column_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variants`)
};

export const knowledge_empty_products_body = /** @type {(inputs: Knowledge_Empty_Products_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products appear here when they are available in your Shopify store.`)
};

export const knowledge_empty_products_heading = /** @type {(inputs: Knowledge_Empty_Products_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Shopify products yet`)
};

export const knowledge_empty_questions_body = /** @type {(inputs: Knowledge_Empty_Questions_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published questions and answers from MyQA Online will appear here.`)
};

export const knowledge_empty_questions_heading = /** @type {(inputs: Knowledge_Empty_Questions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No questions & answers yet`)
};

export const knowledge_empty_search_body = /** @type {(inputs: Knowledge_Empty_Search_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a different search term or clear the filters.`)
};

export const knowledge_empty_search_heading = /** @type {(inputs: Knowledge_Empty_Search_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No products match your search`)
};

export const knowledge_failure_forbidden = /** @type {(inputs: Knowledge_Failure_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Reopen the admin from Shopify.`)
};

export const knowledge_failure_network = /** @type {(inputs: Knowledge_Failure_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach GoNovus. Check your connection and try again.`)
};

export const knowledge_failure_rejected = /** @type {(inputs: Knowledge_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store knowledge is unavailable right now.`)
};

export const knowledge_failure_schema = /** @type {(inputs: Knowledge_Failure_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store knowledge came back in an unexpected shape.`)
};

export const knowledge_failure_unexpected = /** @type {(inputs: Knowledge_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong loading store knowledge.`)
};

export const knowledge_inventory_untracked = /** @type {(inputs: Knowledge_Inventory_UntrackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

export const knowledge_load_more = /** @type {(inputs: Knowledge_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

export const knowledge_loading = /** @type {(inputs: Knowledge_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading`)
};

export const knowledge_loading_more = /** @type {(inputs: Knowledge_Loading_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading more`)
};

export const knowledge_page_title = /** @type {(inputs: Knowledge_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge`)
};

export const knowledge_product_meta = /** @type {(inputs: Knowledge_Product_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category} · ${i?.price} · Inventory ${i?.inventory} · Variants ${i?.variants}`)
};

export const knowledge_search_label = /** @type {(inputs: Knowledge_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products`)
};

export const knowledge_search_placeholder = /** @type {(inputs: Knowledge_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products…`)
};

export const knowledge_tab_products = /** @type {(inputs: Knowledge_Tab_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

export const knowledge_tab_questions = /** @type {(inputs: Knowledge_Tab_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions & answers`)
};

export const knowledge_tabs_label = /** @type {(inputs: Knowledge_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knowledge categories`)
};

export const knowledge_test_in_playground = /** @type {(inputs: Knowledge_Test_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test in Playground`)
};

export const playground_failure_forbidden = /** @type {(inputs: Playground_Failure_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Reopen the admin from Shopify.`)
};

export const playground_failure_network = /** @type {(inputs: Playground_Failure_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach GoNovus. Check your connection and try again.`)
};

export const playground_failure_rejected = /** @type {(inputs: Playground_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start a test conversation right now.`)
};

export const playground_failure_schema = /** @type {(inputs: Playground_Failure_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The test conversation came back in an unexpected shape.`)
};

export const playground_failure_unexpected = /** @type {(inputs: Playground_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong starting a test conversation.`)
};

export const playground_live_config = /** @type {(inputs: Playground_Live_ConfigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testing live configuration`)
};

export const playground_page_title = /** @type {(inputs: Playground_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playground`)
};

export const playground_real_business_notice = /** @type {(inputs: Playground_Real_Business_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This test uses real customer orders and sends real emails to your support address. Sign in as the customer to check orders. New test clears authorization and unsent requests; emails already submitted are kept.`)
};

export const playground_reset = /** @type {(inputs: Playground_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New test`)
};

export const settings_agent_copy = /** @type {(inputs: Settings_Agent_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The name shoppers see in chat.`)
};

export const settings_agent_name_label = /** @type {(inputs: Settings_Agent_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent name`)
};

export const settings_character_hint = /** @type {(inputs: Settings_Character_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watercolor glass fades your theme color toward the edges and blurs the page behind the character. Very light theme colors stay solid so the eyes remain visible.`)
};

export const settings_character_label = /** @type {(inputs: Settings_Character_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character`)
};

export const settings_character_solid = /** @type {(inputs: Settings_Character_SolidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solid`)
};

export const settings_character_watercolor = /** @type {(inputs: Settings_Character_WatercolorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watercolor glass`)
};

export const settings_color_picker_label = /** @type {(inputs: Settings_Color_Picker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color picker`)
};

export const settings_color_shape_heading = /** @type {(inputs: Settings_Color_Shape_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color & shape`)
};

export const settings_copy_button_copy = /** @type {(inputs: Settings_Copy_Button_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adds a copy button under each AI reply.`)
};

export const settings_copy_button_title = /** @type {(inputs: Settings_Copy_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let shoppers copy replies`)
};

export const settings_direction_editorial = /** @type {(inputs: Settings_Direction_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial`)
};

export const settings_direction_hairline = /** @type {(inputs: Settings_Direction_HairlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hairline`)
};

export const settings_direction_hint = /** @type {(inputs: Settings_Direction_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hairline keeps thin dividers. Editorial shows assistant replies without bubble backgrounds.`)
};

export const settings_direction_label = /** @type {(inputs: Settings_Direction_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

export const settings_disable_cancel = /** @type {(inputs: Settings_Disable_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep it visible`)
};

export const settings_disable_confirm = /** @type {(inputs: Settings_Disable_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide chatbox`)
};

export const settings_disable_description = /** @type {(inputs: Settings_Disable_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoppers stop seeing the assistant as soon as you save. Existing conversations are not deleted.`)
};

export const settings_disable_title = /** @type {(inputs: Settings_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide the chatbox on your storefront?`)
};

export const settings_discard = /** @type {(inputs: Settings_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard changes`)
};

export const settings_error_agent_name = /** @type {(inputs: Settings_Error_Agent_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an agent name of 1 to 40 characters.`)
};

export const settings_error_go_to_tab = /** @type {(inputs: Settings_Error_Go_To_TabInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Go to ${i?.tab}`)
};

export const settings_error_proactive_rules = /** @type {(inputs: Settings_Error_Proactive_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A proactive rule in Proactive messages needs attention.`)
};

export const settings_error_rule_prompt = /** @type {(inputs: Settings_Error_Rule_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter 1 to 200 characters of plain text. ${i?.placeholder} is the only placeholder.`)
};

export const settings_error_rule_question = /** @type {(inputs: Settings_Error_Rule_QuestionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter 1 to 1000 characters of plain text. ${i?.placeholder} is the only placeholder.`)
};

export const settings_error_rule_selector = /** @type {(inputs: Settings_Error_Rule_SelectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An enabled element rule needs a target element.`)
};

export const settings_error_rule_wait = /** @type {(inputs: Settings_Error_Rule_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a whole number of seconds from 1 to 300.`)
};

export const settings_error_suggested_question = /** @type {(inputs: Settings_Error_Suggested_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a question of 1 to 80 characters, or remove this row.`)
};

export const settings_error_suggested_question_duplicate = /** @type {(inputs: Settings_Error_Suggested_Question_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This question is already in the list.`)
};

export const settings_error_support_email = /** @type {(inputs: Settings_Error_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid support email address.`)
};

export const settings_error_tab_fields = /** @type {(inputs: Settings_Error_Tab_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has fields that need attention.`)
};

export const settings_error_theme_color = /** @type {(inputs: Settings_Error_Theme_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a 6-digit Hex color, for example #E4649B.`)
};

export const settings_error_welcome_message = /** @type {(inputs: Settings_Error_Welcome_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a welcome message of 1 to 80 characters.`)
};

export const settings_failure_forbidden = /** @type {(inputs: Settings_Failure_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Reopen the admin from Shopify.`)
};

export const settings_failure_network = /** @type {(inputs: Settings_Failure_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach GoNovus. Check your connection and try again.`)
};

export const settings_failure_rejected = /** @type {(inputs: Settings_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings are unavailable right now.`)
};

export const settings_failure_schema = /** @type {(inputs: Settings_Failure_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings came back in an unexpected shape.`)
};

export const settings_failure_unexpected = /** @type {(inputs: Settings_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong loading settings.`)
};

export const settings_font_hint = /** @type {(inputs: Settings_Font_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to the whole Chatbox — the launcher, prompts and the chat window. It does not change the GoNovus admin interface.`)
};

export const settings_font_label = /** @type {(inputs: Settings_Font_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font`)
};

export const settings_font_sans = /** @type {(inputs: Settings_Font_SansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean Sans`)
};

export const settings_font_serif = /** @type {(inputs: Settings_Font_SerifInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial Serif`)
};

export const settings_font_size_label = /** @type {(inputs: Settings_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text size`)
};

export const settings_font_size_large = /** @type {(inputs: Settings_Font_Size_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large · 16px`)
};

export const settings_font_size_small = /** @type {(inputs: Settings_Font_Size_SmallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small · 13px`)
};

export const settings_font_size_standard = /** @type {(inputs: Settings_Font_Size_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard · 14px`)
};

export const settings_font_theme = /** @type {(inputs: Settings_Font_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match store theme`)
};

export const settings_glass_hint = /** @type {(inputs: Settings_Glass_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makes the chatbox translucent and blurs the page behind it. Busy product photos show through, so check the preview before you save.`)
};

export const settings_glass_label = /** @type {(inputs: Settings_Glass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frosted glass`)
};

export const settings_glass_off = /** @type {(inputs: Settings_Glass_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

export const settings_glass_on = /** @type {(inputs: Settings_Glass_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On`)
};

export const settings_handoff_copy = /** @type {(inputs: Settings_Handoff_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests go only to your verified support email. Reply-To lets you reply directly to the shopper.`)
};

export const settings_handoff_heading = /** @type {(inputs: Settings_Handoff_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human handoff`)
};

export const settings_hex_label = /** @type {(inputs: Settings_Hex_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hex value`)
};

export const settings_launcher_drag_copy = /** @type {(inputs: Settings_Launcher_Drag_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoppers can drag it to either side. Turn off to keep it at the position above.`)
};

export const settings_launcher_drag_title = /** @type {(inputs: Settings_Launcher_Drag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let shoppers move the character`)
};

export const settings_leave_cancel = /** @type {(inputs: Settings_Leave_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay`)
};

export const settings_leave_confirm = /** @type {(inputs: Settings_Leave_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave`)
};

export const settings_leave_description = /** @type {(inputs: Settings_Leave_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your changes have not been saved yet.`)
};

export const settings_leave_title = /** @type {(inputs: Settings_Leave_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave without saving?`)
};

export const settings_loading = /** @type {(inputs: Settings_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading settings`)
};

export const settings_logo_alt = /** @type {(inputs: Settings_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand logo`)
};

export const settings_logo_failure_too_large = /** @type {(inputs: Settings_Logo_Failure_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That file is over 2 MB. Your current logo is unchanged.`)
};

export const settings_logo_failure_type = /** @type {(inputs: Settings_Logo_Failure_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a PNG, JPG or WebP file. Your current logo is unchanged.`)
};

export const settings_logo_failure_unexpected = /** @type {(inputs: Settings_Logo_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not upload that logo. Your current logo is unchanged.`)
};

export const settings_logo_file_label = /** @type {(inputs: Settings_Logo_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo file`)
};

export const settings_logo_hint = /** @type {(inputs: Settings_Logo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNG, JPG or WebP, up to 2 MB. A square image works best. Shoppers see it in the chat header.`)
};

export const settings_logo_label = /** @type {(inputs: Settings_Logo_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand logo`)
};

export const settings_logo_remove = /** @type {(inputs: Settings_Logo_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const settings_logo_replace = /** @type {(inputs: Settings_Logo_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

export const settings_logo_upload = /** @type {(inputs: Settings_Logo_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload logo`)
};

export const settings_messages_heading = /** @type {(inputs: Settings_Messages_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages`)
};

export const settings_page_title = /** @type {(inputs: Settings_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const settings_position_bottom_left = /** @type {(inputs: Settings_Position_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom left`)
};

export const settings_position_bottom_right = /** @type {(inputs: Settings_Position_Bottom_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom right`)
};

export const settings_position_label = /** @type {(inputs: Settings_Position_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

export const settings_preview_conversation = /** @type {(inputs: Settings_Preview_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat window`)
};

export const settings_preview_desktop = /** @type {(inputs: Settings_Preview_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop`)
};

export const settings_preview_device_label = /** @type {(inputs: Settings_Preview_Device_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview device`)
};

export const settings_preview_heading = /** @type {(inputs: Settings_Preview_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

export const settings_preview_hidden = /** @type {(inputs: Settings_Preview_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatbox hidden on storefront`)
};

export const settings_preview_launcher = /** @type {(inputs: Settings_Preview_LauncherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

export const settings_preview_mobile = /** @type {(inputs: Settings_Preview_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

export const settings_preview_proactive = /** @type {(inputs: Settings_Preview_ProactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proactive prompt`)
};

export const settings_preview_store_name = /** @type {(inputs: Settings_Preview_Store_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YOUR STORE`)
};

export const settings_preview_view_label = /** @type {(inputs: Settings_Preview_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview view`)
};

export const settings_proactive_add = /** @type {(inputs: Settings_Proactive_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add rule`)
};

export const settings_proactive_copy = /** @type {(inputs: Settings_Proactive_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome shoppers or offer help as they browse. Rules run top to bottom and the first match shows its prompt. Changes apply when you save.`)
};

export const settings_proactive_delete = /** @type {(inputs: Settings_Proactive_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete rule ${i?.position}`)
};

export const settings_proactive_delete_cancel = /** @type {(inputs: Settings_Proactive_Delete_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep rule`)
};

export const settings_proactive_delete_confirm = /** @type {(inputs: Settings_Proactive_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete rule`)
};

export const settings_proactive_delete_description = /** @type {(inputs: Settings_Proactive_Delete_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rule is removed when you save changes.`)
};

export const settings_proactive_delete_title = /** @type {(inputs: Settings_Proactive_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this rule?`)
};

export const settings_proactive_edit = /** @type {(inputs: Settings_Proactive_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Edit rule ${i?.position}`)
};

export const settings_proactive_empty_body = /** @type {(inputs: Settings_Proactive_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a rule to welcome shoppers when they enter your store, help when they linger on a product page, or respond when an element stays on screen.`)
};

export const settings_proactive_empty_heading = /** @type {(inputs: Settings_Proactive_Empty_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No proactive rules`)
};

export const settings_proactive_enable = /** @type {(inputs: Settings_Proactive_EnableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enable rule ${i?.position}`)
};

export const settings_proactive_field_count = /** @type {(inputs: Settings_Proactive_Field_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.max}`)
};

export const settings_proactive_heading = /** @type {(inputs: Settings_Proactive_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proactive messages`)
};

export const settings_proactive_insert_placeholder = /** @type {(inputs: Settings_Proactive_Insert_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insert ${i?.placeholder}`)
};

export const settings_proactive_move_down = /** @type {(inputs: Settings_Proactive_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move rule ${i?.position} down`)
};

export const settings_proactive_move_up = /** @type {(inputs: Settings_Proactive_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move rule ${i?.position} up`)
};

export const settings_proactive_no_prompt = /** @type {(inputs: Settings_Proactive_No_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No prompt yet`)
};

export const settings_proactive_pick = /** @type {(inputs: Settings_Proactive_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick element`)
};

export const settings_proactive_pick_again = /** @type {(inputs: Settings_Proactive_Pick_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a different element`)
};

export const settings_proactive_pick_applied = /** @type {(inputs: Settings_Proactive_Pick_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picked element applied to the rule.`)
};

export const settings_proactive_pick_blocked = /** @type {(inputs: Settings_Proactive_Pick_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish or cancel picking before saving changes.`)
};

export const settings_proactive_pick_cancel = /** @type {(inputs: Settings_Proactive_Pick_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel picking`)
};

export const settings_proactive_pick_cancel_failed = /** @type {(inputs: Settings_Proactive_Pick_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not confirm the pick was canceled — the storefront may still write to this rule. Try again.`)
};

export const settings_proactive_pick_conflict = /** @type {(inputs: Settings_Proactive_Pick_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new target element was saved on your storefront. Apply it to this draft or keep your edits.`)
};

export const settings_proactive_pick_conflict_blocked = /** @type {(inputs: Settings_Proactive_Pick_Conflict_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply or dismiss the picked element in Proactive messages before saving.`)
};

export const settings_proactive_pick_dismiss = /** @type {(inputs: Settings_Proactive_Pick_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

export const settings_proactive_pick_embed_hint = /** @type {(inputs: Settings_Proactive_Pick_Embed_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picking runs on your storefront and needs the GoNovus app embed enabled in your theme. The chatbox itself can stay hidden.`)
};

export const settings_proactive_pick_failure_popup = /** @type {(inputs: Settings_Proactive_Pick_Failure_PopupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser blocked the new tab. Allow pop-ups and try again.`)
};

export const settings_proactive_pick_failure_rejected = /** @type {(inputs: Settings_Proactive_Pick_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start picking for this rule. Refresh the page and try again.`)
};

export const settings_proactive_pick_failure_unexpected = /** @type {(inputs: Settings_Proactive_Pick_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start picking. Try again.`)
};

export const settings_proactive_pick_gone = /** @type {(inputs: Settings_Proactive_Pick_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This rule was deleted or changed while you were picking — nothing was applied.`)
};

export const settings_proactive_pick_keep = /** @type {(inputs: Settings_Proactive_Pick_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep my edits`)
};

export const settings_proactive_pick_save_first = /** @type {(inputs: Settings_Proactive_Pick_Save_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes to pick an element on your storefront.`)
};

export const settings_proactive_pick_use = /** @type {(inputs: Settings_Proactive_Pick_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use picked element`)
};

export const settings_proactive_picking = /** @type {(inputs: Settings_Proactive_PickingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picking on your storefront — this rule updates when you come back.`)
};

export const settings_proactive_prompt_hint = /** @type {(inputs: Settings_Proactive_Prompt_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Replaces the chat button when this rule matches. Tapping it opens the chat with this as the assistant's message. ${i?.placeholder} inserts the product title.`)
};

export const settings_proactive_prompt_label = /** @type {(inputs: Settings_Proactive_Prompt_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt`)
};

export const settings_proactive_question_hint = /** @type {(inputs: Settings_Proactive_Question_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prefilled in the message box when the shopper opens the prompt. They can edit it before sending. ${i?.placeholder} inserts the product title.`)
};

export const settings_proactive_question_label = /** @type {(inputs: Settings_Proactive_Question_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefilled question`)
};

export const settings_proactive_rule = /** @type {(inputs: Settings_Proactive_RuleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rule ${i?.position}`)
};

export const settings_proactive_selector_hint = /** @type {(inputs: Settings_Proactive_Selector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A CSS selector that matches exactly one element, without #ids. Clearing the target turns the rule off.`)
};

export const settings_proactive_selector_label = /** @type {(inputs: Settings_Proactive_Selector_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target element`)
};

export const settings_proactive_target_required = /** @type {(inputs: Settings_Proactive_Target_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This rule stays off until you pick or enter a target element. To pick one, fill in the prompt and prefilled question, save changes, then choose Pick element.`)
};

export const settings_proactive_trigger_element = /** @type {(inputs: Settings_Proactive_Trigger_ElementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element visible`)
};

export const settings_proactive_trigger_element_hint = /** @type {(inputs: Settings_Proactive_Trigger_Element_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the prompt after the target element stays on screen for this long.`)
};

export const settings_proactive_trigger_entry = /** @type {(inputs: Settings_Proactive_Trigger_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store entry`)
};

export const settings_proactive_trigger_entry_hint = /** @type {(inputs: Settings_Proactive_Trigger_Entry_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome shoppers on any page, once per browser tab. Scrolling and clicking do not restart the wait. Skip this welcome if chat has already been opened or any proactive prompt has been shown in this tab.`)
};

export const settings_proactive_trigger_idle = /** @type {(inputs: Settings_Proactive_Trigger_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product page idle`)
};

export const settings_proactive_trigger_idle_hint = /** @type {(inputs: Settings_Proactive_Trigger_Idle_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the prompt after the shopper spends this long on a product page without scrolling, clicking or typing.`)
};

export const settings_proactive_trigger_label = /** @type {(inputs: Settings_Proactive_Trigger_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trigger`)
};

export const settings_proactive_wait_label = /** @type {(inputs: Settings_Proactive_Wait_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait before showing`)
};

export const settings_proactive_wait_suffix = /** @type {(inputs: Settings_Proactive_Wait_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`seconds`)
};

export const settings_prompt_style_body = /** @type {(inputs: Settings_Prompt_Style_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expanded character`)
};

export const settings_prompt_style_bubble = /** @type {(inputs: Settings_Prompt_Style_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separate bubble`)
};

export const settings_prompt_style_hint = /** @type {(inputs: Settings_Prompt_Style_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies to all proactive prompts on desktop and mobile. Preview it using the Proactive prompt view.`)
};

export const settings_prompt_style_label = /** @type {(inputs: Settings_Prompt_Style_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt style`)
};

export const settings_radius_label = /** @type {(inputs: Settings_Radius_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corners`)
};

export const settings_radius_preset = /** @type {(inputs: Settings_Radius_PresetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset`)
};

export const settings_radius_round = /** @type {(inputs: Settings_Radius_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra rounded`)
};

export const settings_radius_rounded = /** @type {(inputs: Settings_Radius_RoundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rounded`)
};

export const settings_radius_square = /** @type {(inputs: Settings_Radius_SquareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Square`)
};

export const settings_save = /** @type {(inputs: Settings_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes`)
};

export const settings_save_failed = /** @type {(inputs: Settings_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

export const settings_save_failure_rejected = /** @type {(inputs: Settings_Save_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The server rejected these settings. Check the fields and try again.`)
};

export const settings_save_failure_unexpected = /** @type {(inputs: Settings_Save_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong saving your settings.`)
};

export const settings_save_hint = /** @type {(inputs: Settings_Save_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes apply to Playground and the embedded storefront after saving.`)
};

export const settings_save_success = /** @type {(inputs: Settings_Save_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings saved`)
};

export const settings_saved = /** @type {(inputs: Settings_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

export const settings_saving = /** @type {(inputs: Settings_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving…`)
};

export const settings_suggested_question_label = /** @type {(inputs: Settings_Suggested_Question_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suggested question ${i?.position}`)
};

export const settings_suggested_question_move_down = /** @type {(inputs: Settings_Suggested_Question_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move suggested question ${i?.position} down`)
};

export const settings_suggested_question_move_up = /** @type {(inputs: Settings_Suggested_Question_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move suggested question ${i?.position} up`)
};

export const settings_suggested_question_remove = /** @type {(inputs: Settings_Suggested_Question_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove suggested question ${i?.position}`)
};

export const settings_suggested_questions_add = /** @type {(inputs: Settings_Suggested_Questions_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add question`)
};

export const settings_suggested_questions_hint = /** @type {(inputs: Settings_Suggested_Questions_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listed under the welcome message before shoppers send anything. Tapping one asks it for them. Up to 80 characters each.`)
};

export const settings_suggested_questions_label = /** @type {(inputs: Settings_Suggested_Questions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested questions`)
};

export const settings_suggested_questions_limit = /** @type {(inputs: Settings_Suggested_Questions_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 3 questions`)
};

export const settings_support_email_hint = /** @type {(inputs: Settings_Support_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used for product, policy and pre-sale questions.`)
};

export const settings_support_email_label = /** @type {(inputs: Settings_Support_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support email`)
};

export const settings_support_failed_body = /** @type {(inputs: Settings_Support_Failed_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong on our side, not with your address. Try again in a few minutes.`)
};

export const settings_support_failed_title = /** @type {(inputs: Settings_Support_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t send the verification email`)
};

export const settings_support_hint_unsaved = /** @type {(inputs: Settings_Support_Hint_UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save changes to send a verification link to this address.`)
};

export const settings_support_hint_verified = /** @type {(inputs: Settings_Support_Hint_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer requests are emailed here.`)
};

export const settings_support_mark_unsaved = /** @type {(inputs: Settings_Support_Mark_UnsavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not saved`)
};

export const settings_support_mark_unverified = /** @type {(inputs: Settings_Support_Mark_UnverifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not verified`)
};

export const settings_support_mark_verified = /** @type {(inputs: Settings_Support_Mark_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

export const settings_support_pending_body = /** @type {(inputs: Settings_Support_Pending_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent it to ${i?.email}. Customer requests won’t be emailed until you open the link. It expires in 24 hours.`)
};

export const settings_support_pending_title = /** @type {(inputs: Settings_Support_Pending_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your inbox for a verification link`)
};

export const settings_support_resend = /** @type {(inputs: Settings_Support_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend verification email`)
};

export const settings_support_resend_wait = /** @type {(inputs: Settings_Support_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend in ${i?.seconds}s`)
};

export const settings_support_resent_body = /** @type {(inputs: Settings_Support_Resent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the link in the newest email. Links in earlier emails no longer work.`)
};

export const settings_support_resent_title = /** @type {(inputs: Settings_Support_Resent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New verification email sent`)
};

export const settings_support_send = /** @type {(inputs: Settings_Support_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send verification email`)
};

export const settings_support_sending = /** @type {(inputs: Settings_Support_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

export const settings_support_sent_at = /** @type {(inputs: Settings_Support_Sent_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent at ${i?.time}`)
};

export const settings_support_try_again = /** @type {(inputs: Settings_Support_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

export const settings_support_unavailable_body = /** @type {(inputs: Settings_Support_Unavailable_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email sending isn’t set up yet. Try again later, or contact GoNovus support if this keeps happening.`)
};

export const settings_support_unavailable_title = /** @type {(inputs: Settings_Support_Unavailable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification emails aren’t available right now`)
};

export const settings_support_unsent_body = /** @type {(inputs: Settings_Support_Unsent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We’ll send a verification link to ${i?.email}. Customer requests won’t be emailed until you open it.`)
};

export const settings_support_unsent_title = /** @type {(inputs: Settings_Support_Unsent_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify this address to receive requests`)
};

export const settings_surface_dark = /** @type {(inputs: Settings_Surface_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

export const settings_surface_hint = /** @type {(inputs: Settings_Surface_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick the one that matches your storefront. Text and border colors are derived from it.`)
};

export const settings_surface_label = /** @type {(inputs: Settings_Surface_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background`)
};

export const settings_surface_light = /** @type {(inputs: Settings_Surface_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

export const settings_swatch_custom = /** @type {(inputs: Settings_Swatch_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

export const settings_swatch_default = /** @type {(inputs: Settings_Swatch_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

export const settings_swatch_forest = /** @type {(inputs: Settings_Swatch_ForestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest`)
};

export const settings_swatch_indigo = /** @type {(inputs: Settings_Swatch_IndigoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indigo`)
};

export const settings_swatch_luxury = /** @type {(inputs: Settings_Swatch_LuxuryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luxury`)
};

export const settings_swatch_minimal = /** @type {(inputs: Settings_Swatch_MinimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimal`)
};

export const settings_swatch_playful = /** @type {(inputs: Settings_Swatch_PlayfulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playful`)
};

export const settings_swatch_rose = /** @type {(inputs: Settings_Swatch_RoseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rose`)
};

export const settings_swatch_warm = /** @type {(inputs: Settings_Swatch_WarmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm`)
};

export const settings_tab_appearance = /** @type {(inputs: Settings_Tab_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

export const settings_tab_chat_window = /** @type {(inputs: Settings_Tab_Chat_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat window`)
};

export const settings_tab_handoff = /** @type {(inputs: Settings_Tab_HandoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human handoff`)
};

export const settings_tab_launcher = /** @type {(inputs: Settings_Tab_LauncherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launcher`)
};

export const settings_tab_needs_attention = /** @type {(inputs: Settings_Tab_Needs_AttentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`needs attention`)
};

export const settings_tab_proactive = /** @type {(inputs: Settings_Tab_ProactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proactive messages`)
};

export const settings_tabs_label = /** @type {(inputs: Settings_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings sections`)
};

export const settings_text_heading = /** @type {(inputs: Settings_Text_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

export const settings_theme_color_hint = /** @type {(inputs: Settings_Theme_Color_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presets apply matching text, background, header and corners. Use the color picker or Hex value for a custom color. The preview updates before you save.`)
};

export const settings_theme_color_label = /** @type {(inputs: Settings_Theme_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme color`)
};

export const settings_theme_editor = /** @type {(inputs: Settings_Theme_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open theme editor`)
};

export const settings_title_bar_heading = /** @type {(inputs: Settings_Title_Bar_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title bar`)
};

export const settings_visibility_pending = /** @type {(inputs: Settings_Visibility_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applies after you save.`)
};

export const settings_visibility_title = /** @type {(inputs: Settings_Visibility_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show chatbox on storefront`)
};

export const settings_welcome_count = /** @type {(inputs: Settings_Welcome_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} / ${i?.max}`)
};

export const settings_welcome_heading = /** @type {(inputs: Settings_Welcome_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome screen`)
};

export const settings_welcome_hint = /** @type {(inputs: Settings_Welcome_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown when shoppers first open chat.`)
};

export const settings_welcome_label = /** @type {(inputs: Settings_Welcome_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome message`)
};

export const store_connection_error_heading = /** @type {(inputs: Store_Connection_Error_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to load your store`)
};

export const store_connection_expired_heading = /** @type {(inputs: Store_Connection_Expired_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session expired`)
};

export const store_connection_failure_forbidden = /** @type {(inputs: Store_Connection_Failure_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session expired. Reopen the admin from Shopify.`)
};

export const store_connection_failure_network = /** @type {(inputs: Store_Connection_Failure_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach GoNovus. Check your connection and try again.`)
};

export const store_connection_failure_rejected = /** @type {(inputs: Store_Connection_Failure_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store details are unavailable right now.`)
};

export const store_connection_failure_schema = /** @type {(inputs: Store_Connection_Failure_SchemaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Store details came back in an unexpected shape.`)
};

export const store_connection_failure_unexpected = /** @type {(inputs: Store_Connection_Failure_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong loading store details.`)
};

export const store_connection_preparing_body = /** @type {(inputs: Store_Connection_Preparing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are finishing setup for your store. Please check back shortly.`)
};

export const store_connection_preparing_heading = /** @type {(inputs: Store_Connection_Preparing_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your AI assistant is being prepared`)
};

export const store_connection_refresh = /** @type {(inputs: Store_Connection_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

export const store_entry_body = /** @type {(inputs: Store_Entry_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each store has its own admin. Open GoNovus from the Shopify admin of the store you want to manage.`)
};

export const store_entry_heading = /** @type {(inputs: Store_Entry_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open GoNovus from Shopify`)
};